var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"fill-rule":"nonzero","d":"M3.422 9.08l.97.92.972-.92L13 1.84 11.058 0 4.393 6.344l-2.45-2.35L0 5.837z"}})}
var staticRenderFns = []

export { render, staticRenderFns }